$(document).ready(function () {
    // Search will hide/show relevant outcomes
    $('#searchterm').keyup(function () {
        var value = $(this).val();

        if (value === '') {
            $('div.checkbox').show();
        } else {
            var regex = new RegExp(value, 'i');

            $('div.checkbox').each(function () {
                if (regex.test($(this).find('span').text())) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }
    });
});
